import { ComponentType, memo, useEffect } from 'react';
import { useRouter } from 'next/router';
import axios from 'axios';

import { Session, AppProps, Config, ConfigContext } from '@bolttech/essentials';

const WithSession = (
  WrappedComponent: ComponentType<AppProps>,
  useSession: () => Session,
  useConfig: () => ConfigContext<Config>,
): ComponentType<AppProps> =>
  memo(function MemonizedWithSession(props: AppProps): JSX.Element {
    const session = useSession();
    const { locale, vertical } = useConfig();
    const { query } = useRouter();
    const { cookie, setSessionStore } = session;

    useEffect(() => {
      if (
        typeof window === 'undefined' ||
        typeof cookie !== 'undefined' ||
        (query.slug &&
          query.slug.length > 0 &&
          !query.slug.includes('desktop') &&
          !query.slug.includes('mobile'))
      )
        return;

      (async () => {
        const res = await axios.post('/api/session/upsert', {
          locale,
          vertical,
          query,
        });
        const { status, result } = res.data;
        if (status) setSessionStore({ ...result, isReady: true });
      })();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <WrappedComponent {...props} session={session} />;
  });

export { WithSession };
